import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const tagDefinition: ResourceDefinition = {
  title: 'Tags',
  nameSingular: 'tag',
  namePlural: 'tags',
  className: 'Tag',
  mainIdentifier: 'name',
  slug: 'taxonomies/tags',
  path: 'tags',
  icon: 'icon-tag',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (tag) => ({
        type: ActionType.Link,
        link: {
          path: `${tagDefinition.path}/${tag.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (tag) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: tag,
          definition: tagDefinition
        }
      })
    }
  ]
}
